<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-07-09 15:17:48
 * @LastEditors: 侯鹏许(houpengxu@qq.com)
 * @LastEditTime: 2019-08-27 19:58:49
 * @Description: file content
 -->
<template>
  <div class="bubble animated fadeInDown" @click="close" :style="bubbleStyle">
    <span>{{winnersCount}}</span>个网友已经
    <span>中奖</span>，您也来试试吧
  </div>
</template>

<script>
import util from "@/utils/utils";
export default {
  components: {},
  props: {},
  data() {
    return {
      winnersCount: util.randomNum(2000, 5000),
      bubbleStyle: {}
    };
  },
  watch: {},
  computed: {},
  methods: {
    close() {
      this.$emit("close");
    }
  },
  created() {
    // if (
    //   window.starfish &&
    //   window.starfish.uaDevice &&
    //   window.starfish.uaDevice.model == "iPhone X"
    // ) {
    //   this.bubbleStyle = {
    //     bottom: "70px"
    //   };
    // }
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
.bubble {
  z-index: 11;
  background-color: rgba(255, 255, 255, 0.95);
  color: #333333;
  border-radius: 16px;
  padding: 6px 10px;
  line-height: 20px;
  position: fixed;
  right: 7%;
  /* tabbar的高度和上下边距之和 */
  bottom: 70px;
  border: 1px solid #d8d8d8;
  font-size: 12px;
  animation-fill-mode: both;
}

.bubble:before {
  position: absolute;
  bottom: -3px;
  right: 42px;
  width: 0;
  height: 0;
  border-left: 3px solid transparent;
  border-right: 3px solid transparent;
  border-top: 4px solid #ffffff;
  font-size: 0;
  line-height: 0;
  content: " ";
  z-index: 1;
}
.bubble:after {
  position: absolute;
  bottom: -5px;
  right: 40px;
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #d8d8d8;
  font-size: 0;
  line-height: 0;
  content: " ";
}

.bubble span {
  color: #ff6f70;
}
</style>